import { ReactNode } from 'react'
import { HomeIndicator } from './HomeIndicator'
import { BackgroundOrbs } from './BackgroundOrbs'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="w-full min-h-screen bg-white relative">
      {/* Background with gradient and orbs */}
      <div className="fixed inset-0 z-0">
        <BackgroundOrbs />
      </div>

      <div className="fixed inset-0 bg-[#f2fbfe] z-0" />
      
      {/* Main Content */}
      <main className="relative w-full min-h-screen z-10">
        {children}
      </main>
      
      {/* Home Indicator */}
      <HomeIndicator />
    </div>
  )
} 